import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Shield } from 'lucide-react';
import './Hero.css';

const CALENDLY_URL = 'https://calendly.com/aventalentadvisory/o-1-visa-consultation';

function Hero() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <section className="hero-section">
      {/* Subtle gradient orb */}
      <div className="hero-gradient-orb"></div>

      <motion.div
        className="hero-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="hero-content">
          <motion.div variants={itemVariants} className="hero-trust-badge">
            <Shield size={14} />
            <span>A U.S.-based talent representation and advisory firm</span>
          </motion.div>

          <motion.h1 variants={itemVariants} className="hero-headline">
            O-1 Visa Advisory for <span className="hero-highlight">Exceptional Talent</span>
          </motion.h1>

          <motion.p variants={itemVariants} className="hero-subheadline">
            Strategic advisory and agent coordination for founders, consultants, researchers, and
            highly accomplished professionals pursuing O-1–caliber work in the United States.
          </motion.p>

          <motion.div variants={itemVariants} className="hero-actions">
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-btn-primary"
            >
              Schedule an O-1 Advisory Consultation
            </a>
            <a href="#agent-based" className="hero-btn-secondary">
              Learn how the agent-based O-1 model works
              <ArrowRight size={16} />
            </a>
          </motion.div>
        </div>

        {/* Abstract graphic element */}
        <motion.div variants={itemVariants} className="hero-graphic">
          <div className="graphic-circle graphic-circle-1"></div>
          <div className="graphic-circle graphic-circle-2"></div>
          <div className="graphic-circle graphic-circle-3"></div>
          <div className="graphic-line graphic-line-1"></div>
          <div className="graphic-line graphic-line-2"></div>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default Hero;
